import z from '@/lib/zod';
import { AI_USAGE_PERIODS } from '@/pages/admin/ai-usage/lib/usage-period-search';
import { optionalSearchInteger } from './search-param-schemas';

/**
 * Utilizzo AI: periodo (mese, ultimi 3 mesi, anno) e mese di riferimento.
 * Anno e mese sono NUMERI: dichiarati stringa, il router li scriveva fra
 * virgolette JSON (`year=%222026%22`). La pagina valida ancora i valori
 * (futuro, anni fuori dal selettore) con `resolveAiUsageSelection`.
 */
export const aiUsageSearchSchema = z.object({
  period: z.enum(AI_USAGE_PERIODS).optional().catch(undefined),
  year: optionalSearchInteger(),
  month: optionalSearchInteger(),
});

export type AiUsageSearch = z.output<typeof aiUsageSearchSchema>;
